import React, { useState } from "react";
import Use_Alternative_Instrument_Form from "./use_Alternative_Instrument_Form/Use_Alternative_Instrument_Form";
import Use_Alternative_Instrument_table from "./use_Alternative_Instrument_table/Use_Alternative_Instrument_table";

function Use_Alternative_Instrument() {
  const [showTable, setShowTable] = useState(false);

  return (
    <>
      <div className="imperiality_Form_div">
        <Use_Alternative_Instrument_Form onProceed={() => setShowTable(true)} />
      </div>

      {showTable && (
        <div className="imperiality_table_div">
          <Use_Alternative_Instrument_table/>
        </div>
      )}
    </>
  );
}

export default Use_Alternative_Instrument;
